import { TableCellContentType } from './types.js';
// Content types that render fixed-width, auto-sized special cells (drag handle, checkbox, action)
// rather than data columns. Shared by HeadRow (column sizing) and the cell/head styling.
export const SPECIAL_CONTENT_TYPES = new Set([
    TableCellContentType.DND,
    TableCellContentType.CHECKBOX,
    TableCellContentType.ACTION,
]);
export const DATA_ATTR_CAN_SCROLL_LEFT = 'data-can-scroll-left';
export const DATA_ATTR_CAN_SCROLL_LEFT_PAST_STICKY = 'data-can-scroll-left-past-sticky';
export const DATA_ATTR_CAN_SCROLL_RIGHT = 'data-can-scroll-right';
export const DATA_ATTR_CAN_SCROLL_TOP = 'data-can-scroll-top';
export const DATA_ATTR_HAS_HORIZONTAL_SCROLLBAR = 'data-has-horizontal-scrollbar';
export const DATA_ATTR_HAS_VERTICAL_SCROLLBAR = 'data-has-vertical-scrollbar';
export const DATA_ATTR_TABLE_SECTION = 'data-table-section';
export const DATA_ATTR_TABLE_GROUP = 'data-table-group';
export const DATA_ATTR_TABLE_ROW = 'data-table-row';
export const DATA_ATTR_TABLE_HEADROW = 'data-table-headrow';
export const DATA_ATTR_IS_EXPANDED = 'data-is-expanded';
export const DATA_ATTR_CONTENT_TYPE = 'data-content-type';
export const DATA_ATTR_TABLE_NODATA = 'data-table-nodata';
export const DATA_ATTR_TABLE_SCROLLABLE = 'data-table-scrollable';
// Set on the scroll wrapper while a row drag is in progress; locks horizontal scroll so the
// drag overlay (which snapshots scrollLeft at drag start) stays aligned with the viewport.
export const DATA_ATTR_DRAGGING = 'data-table-dragging';
export const dataTableSection = { [DATA_ATTR_TABLE_SECTION]: '' };
export const dataTableGroup = { [DATA_ATTR_TABLE_GROUP]: '' };
export const dataTableRow = { [DATA_ATTR_TABLE_ROW]: '' };
export const dataTableNoData = { [DATA_ATTR_TABLE_NODATA]: '' };
export const CSS_VAR_SCROLL_LEFT = '--table-scroll-left';
export const CSS_VAR_SCROLL_TOP = '--table-scroll-top';
export const CSS_VAR_VISIBLE_WIDTH = '--table-visible-width';
export const CSS_VAR_VISIBLE_HEIGHT = '--table-visible-height';
export const TABLE_ROW_EXPANDING_DURATION_MS = 300;
// Cell dimensions
export const DND_CELL_WIDTH = '45px';
export const DND_CELL_WIDTH_PX = 45;
export const CHECKBOX_CELL_WIDTH = '45px';
export const ACTION_CELL_WIDTH = '61px';
export const ACTION_CELL_WIDTH_COMPACT = '45px';
// Padding
export const CELL_PADDING_COMPACT = '8px 12px';
export const CELL_PADDING_DEFAULT = '16px 12px';
export const SECTION_PADDING_COMPACT = '8px 12px';
export const SECTION_PADDING_DEFAULT = '16px 24px';
export const MOBILE_PADDING = '8px 12px';
// Layout
export const BORDER_RADIUS = '8px';
export const GROUP_INDICATOR_WIDTH = '8px';
export const GROUP_SPACING = '8px';
export const ALIGN_TO_FLEX = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
// Stacking order (z-index), kept in one place so sticky headers, scroll dividers, the
// expanded-row outline, group affordances and the sticky special cells layer predictably.
// Higher value sits closer to the viewer.
export const Z_INDEX_ACTION_CELL = 1;
export const Z_INDEX_CHECKBOX_CELL = 2;
export const Z_INDEX_GROUP_HEADER = 2;
export const Z_INDEX_GROUP_INDICATOR = 3;
export const Z_INDEX_EXPANDED_OUTLINE = 4;
// Sits above the expanded-row outline so a row scrolling under the sticky header is covered by it.
export const Z_INDEX_HEADROW = 5;
// Thin sticky separator lines drawn on top of everything (purely cosmetic, pointer-events: none).
export const Z_INDEX_SCROLL_DIVIDER = 5;
